<div *ngIf="!submitted">
  <h1 class="modal__header">Are you sure you want to cancel your policy?</h1>
  <div class="modal__text">
    You are encouraged to contact your financial professional to review the implications of canceling your policy. Once
    your coverage has been canceled, your policy will no longer be inforce and will not be reinstateable.
  </div>
  <div class="modal__actions modal__actions--inline">
    <a *ngIf="href" class="button button--blue button--primary modal__button" href="{{ href }}">Continue</a>
    <a *ngIf="!href" class="button button--blue button--primary modal__button" (click)="cancelPolicy()">Continue</a>
    <button class="button button--blue button--secondary button--no-border modal__button" (click)="closeModal()">
      Exit
    </button>
  </div>
</div>
<div *ngIf="submitted">
  <div class="modal__text" *ngIf="submitted">
    <p>
      We've received your cancellation request. Please allow up to 10 business days for us to confirm the cancellation.
      Any funds withdrawn will be returned to your bank account on record.
    </p>
  </div>
</div>
